// react
import React from "react"
import { connect } from "react-redux"
import { browserHistory } from "react-router"
import DocumentTitle from "react-document-title"
// app
import SearchForm from "components/search/Form"
import { search } from "actions/search/actions.js"


class Search extends React.Component {
    componentWillMount() {
        if (this.props.count > 0) browserHistory.replace("/search/result")
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.count > 0) browserHistory.push("/search/result")
    }

    /*componentDidMount() {
        this.props.clearSearch()
    }*/

    render() {
        return (
            <DocumentTitle title="Search">
                <div className="page">
                    <div className="row">
                        <div className="col-xs-12">
                            <SearchForm
                                onSearch={ this.props.search }
                            />
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        search: criteria => dispatch(search(criteria))
    }
}

function mapStateToProps(state) {
    return {
        criteria: state.search.get("criteria"),
        count: state.search.get("data").size
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)


/** WEBPACK FOOTER **
 ** ./src/containers/Search/Form/search-form.js
 **/